import { ColDef } from "@ag-grid-community/core";

import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import FieldType from "@mapmycustomers/shared/enum/fieldModel/FieldType";

import AgGridFilterOperator from "@app/enum/AgGridFilterOperator";

import baseColumnTypes from "./base-column-types";

// Since our backend does not fully support all possible filter
// combinations, we had to disable specifying secondary (aka AndOr) condition.
export const defaultFilterParams: { [key: string]: any } = {
  buttons: ["reset", "apply"],
  closeOnApply: false,
  suppressAndOrCondition: true,
} as const;

const columnTypes: { [key in string]: ColDef } = {
  ...baseColumnTypes,
  [FieldFeature.WITH_CHECKBOX_SELECTION]: {
    ...baseColumnTypes[FieldFeature.WITH_CHECKBOX_SELECTION],
    headerComponent: "checkboxSelectionHeader",
  },
  [FieldType.DATE]: {
    ...baseColumnTypes[FieldType.DATE],
    filterParams: {
      ...defaultFilterParams,
      filterOptions: [
        AgGridFilterOperator.EQUALS,
        AgGridFilterOperator.NOT_EQUAL,
        AgGridFilterOperator.GREATER_THAN,
        AgGridFilterOperator.GREATER_THAN_OR_EQUAL,
        AgGridFilterOperator.LESS_THAN,
        AgGridFilterOperator.LESS_THAN_OR_EQUAL,
      ],
    },
  },
  [FieldType.DATE_TIME]: {
    ...baseColumnTypes[FieldType.DATE_TIME],
    filterParams: {
      ...defaultFilterParams,
      filterOptions: [
        AgGridFilterOperator.EQUALS,
        AgGridFilterOperator.NOT_EQUAL,
        AgGridFilterOperator.GREATER_THAN,
        AgGridFilterOperator.GREATER_THAN_OR_EQUAL,
        AgGridFilterOperator.LESS_THAN,
        AgGridFilterOperator.LESS_THAN_OR_EQUAL,
      ],
    },
  },
  [FieldType.NUMBER]: {
    ...baseColumnTypes[FieldType.NUMBER],
    filterParams: {
      ...defaultFilterParams,
      filterOptions: [
        AgGridFilterOperator.EQUALS,
        AgGridFilterOperator.NOT_EQUAL,
        AgGridFilterOperator.GREATER_THAN,
        AgGridFilterOperator.GREATER_THAN_OR_EQUAL,
        AgGridFilterOperator.LESS_THAN,
        AgGridFilterOperator.LESS_THAN_OR_EQUAL,
      ],
    },
  },
  [FieldType.STRING]: {
    ...baseColumnTypes[FieldType.STRING],
    filterParams: {
      ...defaultFilterParams,
      filterOptions: [
        AgGridFilterOperator.EQUALS,
        AgGridFilterOperator.NOT_EQUAL,
        AgGridFilterOperator.CONTAINS,
        AgGridFilterOperator.NOT_CONTAINS,
        AgGridFilterOperator.STARTS_WITH,
        AgGridFilterOperator.ENDS_WITH,
      ],
    },
  },
};

export default columnTypes;
